import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	HostBinding,
	Input,
	OnInit,
	Output,
	ViewEncapsulation,
} from "@angular/core";
import { Jurisdiction } from "@obg/core.config";
import { TranslationService } from "@obg/ngx.core.content";
import { RouteLink } from "@obg/ngx.router";

import { CurrentStep } from "../poker-login.model";
@Component({
	selector: "obg-m-common-poker-login-verification",
	templateUrl: "./poker-login-verification.component.html",
	styleUrls: ["./poker-login-verification.component.scss"],
	encapsulation: ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.Default,
})
export class PokerLoginVerificationComponent implements OnInit {
	@HostBinding("class.obg-m-poker-login-verification") hostCssClass = true;

	@Output()
	action = new EventEmitter();

	@Input()
	customerJurisdiction: Jurisdiction | undefined;

	@Input()
	currentStep: CurrentStep = CurrentStep.JurisdictionMismatch;

	@Input()
	authToken: string | undefined;

	@Input()
	pegaJurisdiction: boolean | undefined = false;

	actionUrlLink: RouteLink | string = "";
	descriptionContent = "";
	showActionButton = true;

	constructor(private translationService: TranslationService) {}

	ngOnInit() {
		if (
			this.currentStep === CurrentStep.CountryRestriction ||
			(this.currentStep === CurrentStep.JurisdictionMismatch && this.pegaJurisdiction)
		) {
			this.showActionButton = false;
			this.action.emit();
		}
		const actionUrlKey = `poker-inclient.${this.currentStep}.action-url`;
		const descriptionKey = `poker-inclient.${this.currentStep}.description`;
		const jurisdictionSpecificKey = `${actionUrlKey}.${this.customerJurisdiction?.toLowerCase()}`;
		const jurisdictionSpecificDescriptionKey = `${descriptionKey}.${this.customerJurisdiction?.toLowerCase()}`;
		let actionUrl = this.translationService.getByKey(jurisdictionSpecificKey);
		let description = this.translationService.getByKey(jurisdictionSpecificDescriptionKey);

		if (description === jurisdictionSpecificDescriptionKey) {
			description = this.translationService.getByKey(descriptionKey);
		}
		if (actionUrl === jurisdictionSpecificKey) {
			actionUrl = this.translationService.getByKey(actionUrlKey);
		}

		if (description !== descriptionKey) {
			this.descriptionContent = description;
		}

		if (actionUrl !== actionUrlKey) {
			this.actionUrlLink = { url: actionUrl } as RouteLink;
			if (
				(this.currentStep === CurrentStep.PokerMigration ||
					this.currentStep === CurrentStep.ProfileCompleteness) &&
				this.authToken
			) {
				this.actionUrlLink.url = `${this.actionUrlLink.url}?pokerclientredirect=true&authenticationToken=${encodeURIComponent(this.authToken)}`;
			}
		}
	}
}
